import React from 'react'
import ProfileBody from '../Components/ProfileBody/ProfileBody'
import Footer from '../Components/Footer/Footer'
import ChatBot from '../Components/Chat/ChatBot'
//import Chat from '../Components/Chat/Chat'

function Profile() {
    return (
        <>
        <ProfileBody>
            
        </ProfileBody>

        <Footer/>
        
        {/* <Chat/> */}
        {/* <ChatBot/> */}
        </>
    )
}

export default Profile
